import { memo, useCallback } from 'react';

import IconDislike from '../../../../assets/svg/IconDislike';
import { globalNormalDialogProxy } from '../../../../elements/Dialog';
import Touchable from '../../../../elements/Touchable';
import useActions from '../../../../hooks/useActions';
import { translate } from '../../../../i18n';
import { deleteCartItem } from '../../../../redux/actions/deleteCartItemActions';
import { cartContentAttrSelector } from '../../../../redux/selectors/cartContentSelector';
import { useSelector } from '../../../../redux/utils';
import S from './styles';

const useClearOutOfStock = () => {
  const outOfStockData = useSelector(cartContentAttrSelector('outOfStock'));
  const deleteCart = useActions(deleteCartItem.request);

  return useCallback(() => {
    globalNormalDialogProxy.open({
      positiveText: translate('clear-stockout-dialog-positive'),
      negativeText: translate('clear-stockout-dialog-negative'),
      contentText: translate('clear-stockout-dialog-content'),
      handleDialogPositiveAction: () => {
        const data = outOfStockData || {};

        deleteCart({ virtualProductIDs: Object.keys(data) });
      },
    });
  }, [outOfStockData, deleteCart]);
};

// export only for unit test
export const _makeLogData = (eventLabel: string) => ({
  actionName: 'clean_stockout',
  eventCategory: 'cart',
  eventLabel,
});

export default memo(() => {
  const handleClearPress = useClearOutOfStock();

  const clearText = translate('clear-stockout');

  return (
    <S.Container>
      <IconDislike />
      <S.Text>{translate('cart-missed')}</S.Text>
      <S.Blank />
      <Touchable
        logData={_makeLogData(clearText)}
        accessibilityRole="button"
        onPress={handleClearPress}
      >
        <S.ClearText>{clearText}</S.ClearText>
      </Touchable>
    </S.Container>
  );
});
